<template>
  <router-view />
</template>

<script setup>
import { inject } from 'vue';

import INJECT_KEYS from '@/app/data/inject_keys';

const emitter = inject(INJECT_KEYS.EMITTER);

emitter.$emit('initFavicon');
</script>
